<script lang="ts">
    import Photos from './Photos.svelte';
    import lastNameDict from '../utils/nameDictionary';
    import { intcomma } from 'journalize';

    /** @type {string} */
    export let familyName
    /** @type {string} */
    export let givenName
    /** @type {string} */
    export let party
    /** @type {boolean} */
    export let isWinner
    /** @type {boolean} */
    export let barFace
    /** @type {number} */
    export let votes
    /** @type {number} */
    export let totalVotes
    // /** @type {number} */
    // export let electorsWon
    // /** @type {number} */
    // export let totalElectors
    /** @type {number} */
    export let idx
    /** @type {import('../types.d').Crosswalk} */
    export let lookup;

    const name = `${givenName} ${lastNameDict(familyName) ?lastNameDict(familyName) : familyName }`;

    /**
     * Text to slugify
     * @param {string} text
     */
    function slugify(text) {
        return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
    }
</script>


<div class="bar-row">
    <!-- What happens on mobile? -->
    <!-- image -->
    <div class="bar-label">
        {#if barFace}
            <div class="candidate__cell-headshot {slugify(name)} {party}">
                <Photos
                    name={name}
                    src={lookup.jpg || lookup.png}
                    avif={lookup.avif}
                    webp={lookup.webp}
                    {party}
                />
            </div>
        {/if}
        <!-- name -->
        <div class="bar-name text-{party}">
            {familyName}
            <!-- checkmark -->
            {#if isWinner}
                <span class="candidate__cell-winner candidate__{party}" aria-label="checkmark, winner"> ✓ </span>
            {/if}
        </div>
    </div>
    <!-- bar -->
    <div class="bar-container">
        {#if votes/totalVotes > 0.5}
        <div class="bar-fill fill-{party}" style="width: {(votes/totalVotes)*100}%"></div>
        <div class="bar-percent text-{party}" style="right: {100-(votes/totalVotes)*100}%; text-align:right; color: white; margin-right: 10px;">{Math.round((votes/totalVotes)*1000)/10}%</div>
        {:else if votes > 0}
        <div class="bar-fill fill-{party}" style="width: {(votes/totalVotes)*100}%"></div>
        <div class="bar-percent text-{party}" style="left: {(votes/totalVotes)*100}%">{Math.round((votes/totalVotes)*1000)/10}%</div>
        {:else}
        <div class="bar-fill fill-{party}" style="width: 0%"></div>
        <div class="bar-percent text-{party}" style="left: 0%">0%</div>
        {/if}
    </div>
    <!-- vote count -->
    <div class="bar-votes">{intcomma(votes)} {#if idx == 0} votes{/if}</div>
</div>